<template>
<div>
  <v-btn text :loading="loading" @click="change">
    <slot v-if="owned" name="on">
      <v-icon color="blue">mdi-checkbox-marked</v-icon>
    </slot>
    <slot v-else name="off">
      <v-icon color="blue">mdi-checkbox-blank-outline</v-icon>
    </slot>
  </v-btn>
</div>
</template>

<script>
export default {
  name: 'FilmOwnership',
  props: {
    id: {
      type: Number,
      required: true,
    },
    owned: Boolean,
  },
  data() {
    return {
      loading: false,
    }
  },
  inject: ["httpClient"],
  methods: {
    async change() {
      if (this.loading) return
      this.loading = true
      const response = await this.httpClient.toggleOwn(this.id)
      this.$emit('updateFilm', response)
      this.loading = false
    }
  }
}
</script>
